(function () {
	'use strict';

	var module = angular.module('uwAgenda.settings.administration');
	module.controller('DetailProtocolController', ['$scope', '$filter', 'Alert', 'ProtocolService', 'AppointmentTypeService', '$uibModalInstance', 'protocol', 'protocolCategories', 'appointmentTypes', 'Protocol', DetailProtocolControllerFn]);

	/* controller for protocol details modal */
	function DetailProtocolControllerFn($scope, $filter, Alert, ProtocolService, AppointmentTypeService, $uibModalInstance, protocol, protocolCategories, appointmentTypes, Protocol) {
		var vm = this;
		// current protocol 
		vm.protocol = {};
		// list of all protocol categories
		vm.protocolCategories = [];
		// list of all appointment types for user
		vm.appointmentTypes = [];

		activate();

		// select category
		vm.setCategory = function (category) {
			vm.protocol.protocolCategory = category;
		};

		// select app. type
		vm.setAppointmentType = function (type) {
			vm.protocol.appointmentType = type;
		};

		/* save current item */
		vm.save = function () {
			// object to save
			var saveCopy = new Protocol();
			angular.copy(vm.protocol, saveCopy);

			// prepare for backend 
			saveCopy.prepareForSave();

			// save or update
			if (saveCopy.id > 0) {
				// update
				ProtocolService.update(saveCopy.id, saveCopy).then(function (result) {
					Alert.success("protocol updated successfully");
					// close modal
					$uibModalInstance.close(result);
				});
			} // if
			else {
				// save
				ProtocolService.save(saveCopy).then(function (result) {
					Alert.success("protocol saved successfully");
					// close modal
					$uibModalInstance.close(result);
				});
			} // else
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss("abort");
		};

		// listen on changes
		function listen() {
			// watcher for local selectedUser - check if changed
			var userChangeListener = $scope.$watch(function () {
				return vm.protocol.userDto;
			}, function (newUser, oldVal) {
				// is the same ?
				if (newUser === oldVal) {
					return;
				}// if

				// clear appointmentType 
				vm.protocol.appointmentType = null;
				vm.appointmentTypes = null;

				if (typeof newUser !== 'undefined' && newUser !== null && newUser.lastName) {
					// load appointmenttypes from user
					AppointmentTypeService.queryByUserId(newUser.id, false).then(function (result) {
						vm.appointmentTypes = result;
					});
				}
			});

			// on destroy
			$scope.$on("$destroy", function () {
				userChangeListener();
				userChangeListener = null;
			});
		} // listen

		/* activation work */
		function activate() {
			vm.protocol = protocol;
			vm.protocolCategories = protocolCategories.data;
			vm.appointmentTypes = appointmentTypes;

			// protocol category is required !
			if (typeof vm.protocol.id === 'undefined' || vm.protocol.id < 0) {
				// select first item in list
				vm.protocol.protocolCategory = vm.protocolCategories[0];
			} // if

			// select first appointment type
			if (vm.protocol.fK_AppointmentType !== null) {
				vm.protocol.appointmentType = $filter('filter')(vm.appointmentTypes, { id: vm.protocol.fK_AppointmentType }, true)[0];
			} //if

			// clear
			protocol = null;
			protocolCategories = null;

			//in sidebar default on
			vm.protocol.showInSidebar = true;

			// add watcher
			listen();
		}
	}
})();
